import React, { useEffect, useRef } from 'react';
import { Stream } from '@cloudflare/stream-react';

export default function LazyVideo(props) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  /* const lazyLoader = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        lazyLoader.unobserve(entry.target);
        entry.target.poster = entry.target.dataset.poster;
        entry.target.querySelectorAll('[data-src]').forEach(el => el.src = el.dataset.src)
      }
    });
  }, {
    rootMargin: '20% 0px'
  }); */

  let isIntersecting = false;

  const autoPlayer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        isIntersecting = true;
        if (streamRef.current) {
          streamRef.current.play();
        }
      } else {
        isIntersecting = false;
        if (streamRef.current) {
          streamRef.current.pause();
        }
      }
    });
  }, {
    rootMargin: '0px 0px 0px 0px'
  });

  let aspectRatio = 0;
  if (props.width && props.height) {
    aspectRatio = props.width / props.height;
  }

  useEffect(() => {
    // lazyLoader.observe(videoRef.current);
    autoPlayer.observe(videoRef.current);

    return () => {
      // lazyLoader.unobserve(videoRef.current);
      autoPlayer.unobserve(videoRef.current);
    }
  }, [videoRef.current]);

  const shouldPlay = () => {
    if (isIntersecting && streamRef.current) {
      streamRef.current.play();
    }
  }

  return (
    <div className="promo-block--video-container" style={{'--aspectRatio': aspectRatio}} ref={videoRef}>
      <div className="promo-block--video">
        <Stream {...props} letterboxColor="white" loop playsInline muted streamRef={streamRef} width={props.width} height={props.height} onCanPlay={shouldPlay} responsive={false} />
      </div>
    </div>
  );
}